import { Component } from '@angular/core';
import {
  DictionarySapSymbolEntity,
  DictionarySapSymbolsDataService,
} from '../../../app/shared';
import {
  DataTableDataDefinition,
  CustomButtonDefinition
} from 'src/app/shared/fca-data-table';
import { DictionaryType } from 'src/components/shared/dictionaries-layout';
import { MatDialog } from '@angular/material/dialog';
import { AddNewSapSymbolsDialogComponent } from './add-new-sap-symbols-dialog/add-new-sap-symbols-dialog.component';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'dictionaries-sap-symbols-tab',
  templateUrl: './sap-symbols.component.html',
  styleUrls: ['./sap-symbols.component.scss'],
})
export class DictionarySapSymbolsTab {
  constructor(
    private dataService: DictionarySapSymbolsDataService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {}

  pageSize = 10;
  title = 'Dictionary';
  dictionaryType = DictionaryType.SapSymbols;

  data: DictionarySapSymbolEntity[] | null = null;

  dataDefinition: DataTableDataDefinition<DictionarySapSymbolEntity> = [
    {
      name: '',
      allowGroup: true,
      columns: [
        {
          fieldName: 'symbol',
          caption: 'SAP Symbol',
          valueType: 'text',
          editable: false,
          deletable: true
        },
        {
          fieldName: 'indexName',
          caption: 'Index Name',
          valueType: 'text',
          editable: false,
          deletable: true
        },
        {
          fieldName: 'indexType',
          caption: 'Index Type',
          valueType: 'text',
          editable: false,
          deletable: true
        },
      ],
    },
  ];

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.dataService.getAll().subscribe((receivedData) => {
      this.data = receivedData;
    });
  }

  addSapSymbol() {
    const dialogRef = this.dialog.open(AddNewSapSymbolsDialogComponent, {
      width: '350px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.loadData();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  customButtons: CustomButtonDefinition<DictionarySapSymbolEntity>[] = [
    {
      icon: 'delete_outline',
      hint: 'Delete row',
      onClick: this.confirmDelete.bind(this) as (x: any) => {},
    },
  ];

  isDialogOpen = false;

  confirmDelete(sapSymbol: DictionarySapSymbolEntity) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to remove this item?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        this.dataService.delete(sapSymbol.id).subscribe({
          next: () => {
            this.loadData();
          },
          error: (error) => {
            if (error?.error?.ErrorCode === 'ERROR_DELETE_SAP_SYMBOL') {
              const lines: string[] = error.error.Message.split('\n');
              const records = lines.slice(1).filter((line) => line.trim() !== '');
              const recordsList = records.join('\n');
              const formattedMessage =
                `This SAP Symbol is currently used in Airport Contract List module for following records:\n\n${recordsList}`;

              this.dialog.open(ConfirmationDialogComponent, {
                width: '350px',
                scrollStrategy: new NoopScrollStrategy(),
                panelClass: 'preformatted-dialog',
                data: {
                  title: 'Attention',
                  message: formattedMessage,
                  buttons: {
                    confirm: 'OK',
                  },
                },
              });
            } else {
              this.snackBar.open('An error occurred while deleting the record.', 'Close', { duration: 5000 });
            }
          },
        });
      }
    });
  }
}
